import default_ from "./default.json" with { type: "json" };
import preLoginPages from "./preLoginPages.json" with { type: "json" };

export default {
	...default_,
	preLoginPages,
} as const;
